import { createSimpleEnumSerializer2guioz11kk1m0 as createSimpleEnumSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Enums.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { SortBuilder36qqny2jtmmgx as SortBuilder } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SortBuilder.mjs';
import {
  CareLocation1v3u5wduz023s as CareLocation,
  Companion_getInstance3624xnlg0493t as Companion_getInstance,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/domain.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual2mm942ha7plg6 as serializerOrContextual } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SerializationHelpers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { DataClassPathSelf18kqeagzkbefr as DataClassPathSelf } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/DataClassPath.mjs';
import {
  get_name29bc1mdqu6171 as get_name,
  get_providerName1j4z1getwwg09 as get_providerName,
  get_address1er1ty3qehev7 as get_address,
  get_city182djzl8rp5cw as get_city,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/ModelFields-372156621.mjs';
import {
  Companion_instance13way2il9a8jt as Companion_instance,
  Enum3alwj03lh1n41 as Enum,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { enumEntries20mr21zbe3az4 as enumEntries } from '../../../../../../kotlin-kotlin-stdlib/kotlin/enums/EnumEntries.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance23f213579at67 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import {
  SerializerFactory1qv9hivitncuv as SerializerFactory,
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { AppState_getInstance33x03n2an9aul as AppState_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/AppState.js.mjs';
import { get_stringsy7vodl9dj0ya as get_strings } from '../../strings.mjs';
import {
  allTextFieldsContain2y4ctgpgxc740 as allTextFieldsContain,
  textSearchConditionr2nfggw95qef as textSearchCondition,
  searchField2rc6mst1no9ok as searchField,
} from '../components/search.mjs';
import { get_currentSessionNotNull30vuua77prq38 as get_currentSessionNotNull } from '../../sdk/currentSession.mjs';
import { await1uwe8zvsjq69o as await_0 } from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { EmptySerializersModule991ju6pz9b79 as EmptySerializersModule } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/modules/SerializersModuleBuilders.mjs';
import { StringDeferringConfig2dp4ygunddfnv as StringDeferringConfig } from '../../../../../../kotlinx-serialization-csv-durable/com/lightningkite/kotlinx/serialization/csv/StringDeferringConfig.mjs';
import { CsvFormat2d7d3ollhiney as CsvFormat } from '../../../../../../kotlinx-serialization-csv-durable/com/lightningkite/kotlinx/serialization/csv/CsvFormat.mjs';
import {
  ListSerializer1hxuk9dx5n9du as ListSerializer,
  get_nullable197rfua9r7fsz as get_nullable,
} from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import { toBlob3efqyqa0phgb9 as toBlob } from '../../../../../../kiteui-library/com/lightningkite/kiteui/fetch.js.mjs';
import { download3e9i5zj8k9dp8 as download } from '../../../../../../kiteui-library/com/lightningkite/kiteui/ExternalServices.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import {
  constructCallableReference23y65rf941mch as constructCallableReference,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { LocationDetailPage2zka4ek7qyuhq as LocationDetailPage } from './LocationDetailPage.mjs';
import {
  PhoneNumber__toString_impl_7i2x3q2my82bpxyutrq as PhoneNumber__toString_impl_7i2x3q,
  PhoneNumber16oapr4wkp1a5 as PhoneNumber,
  EmailAddress__toString_impl_artjh3fv1lb2pg4oqn as EmailAddress__toString_impl_artjh3,
  EmailAddress1cvm8sbtoer9i as EmailAddress,
} from '../../../../../../service-abstractions-data-shared/com/lightningkite/services/data/StringAlts.mjs';
import {
  Companion_instance1lm8x0jadqh2g as Companion_instance_0,
  Platform_Web_getInstance2840w5bkfolz8 as Platform_Web_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/Platform.mjs';
import { get_current2r182tjucmm5v as get_current } from '../../../../../../kiteui-library/com/lightningkite/kiteui/Platform.js.mjs';
import {
  Signal1973xs1vkmdcb as Signal,
  _Constant___init__impl__v45mub2qfk15kh5l39c as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
} from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import {
  Companion_getInstance2jahap30xtp3t as Companion_getInstance_0,
  toDuration28gf6ughsr3vf as toDuration,
  toDuration7gy6v749ektt as toDuration_0,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import {
  DurationUnit_SECONDS_getInstance162tnxlnf2fpv as DurationUnit_SECONDS_getInstance,
  DurationUnit_MINUTES_getInstance33ilufdckt9os as DurationUnit_MINUTES_getInstance,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import { get_AppScopes4bqeg21n0qw as get_AppScope } from '../../../../../../reactive/com/lightningkite/reactive/core/AppScope.mjs';
import { debounce3vjzafx7e7d30 as debounce } from '../../../../../../reactive/com/lightningkite/reactive/extensions/debounce.mjs';
import {
  LocationFilters8pzx7as7uqbu as LocationFilters,
  locationFilters82x3gyv9gdze as locationFilters,
  locationFilterChips2ao2wx91nexbk as locationFilterChips,
} from './LocationFilters.mjs';
import { And1a3dbpwh0hxmu as And } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Condition.mjs';
import { remember2m0mx1b5ra75q as remember } from '../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import {
  first58ocm7j58k3q as first,
  toList3jhuyej2anx2q as toList,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { Queryam9ckqg1rxkb as Query } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Query.mjs';
import { get_scrolling3fwkltztkpfe8 as get_scrolling } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import {
  maxWidth22r11xnm7d4h4 as maxWidth,
  sortSelect2bs9xha2fqnl1 as sortSelect,
  exportButton1ekt3fxzrhh34 as exportButton,
} from '../components/view-utilities.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import {
  ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement,
  Companion_getInstanceztgx4sy4wjnt as Companion_getInstance_1,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import {
  CompactSemantic_getInstance3lxnpjuev524m as CompactSemantic_getInstance,
  HeaderSemantic_getInstance20a9id3sf7d4x as HeaderSemantic_getInstance,
  get_H1Semantic28sytsa4fm6nk as get_H1Semantic,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { themed2vu67ornd4jps as themed } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { get_atBottomStart1iulwjfo1udg3 as get_atBottomStart } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  TextView$_get_content_$ref_4pzcwl5a4gnldk8ef9 as TextView$_get_content_$ref_4pzcwl,
  TextView$_set_content_$ref_pketfb11e282hr0m0jl as TextView$_set_content_$ref_pketfb,
} from '../../App.mjs';
import {
  weight31wqab1913ly4 as weight,
  shownWhen3t7othivfr11 as shownWhen,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { Action2nhdpxpznfsbd as Action } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/Action.mjs';
import {
  Companion_instance35wmauq2koet0 as Companion_instance_1,
  tableRecycler8sos3tuo7qum as tableRecycler,
} from '../components/table.mjs';
import { Page1o437w9xuocrm as Page } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import {
  StringSerializer_getInstance1p9zda6r6kb23 as StringSerializer_getInstance,
  BooleanSerializer_getInstance22aja3hu17sxf as BooleanSerializer_getInstance,
} from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Primitives.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  createThis2j2avj17cvnv2 as createThis,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
import { SerializableWithd2dap36updxd as SerializableWith } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializersJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function _get_$cachedSerializer__te6jhj($this) {
  return $this.$cachedSerializer$delegate_1.get_value_j01efc_k$();
}
function LocationsListPage$SortOption$Companion$_anonymous__9ol70d() {
  return createSimpleEnumSerializer('org.thecommunitygroupinc.cares.views.locations.LocationsListPage.SortOption', values());
}
var static_init_called;
function static_init() {
  if (static_init_called)
    return Unit_instance;
  static_init_called = true;
  // Inline function 'com.lightningkite.services.database.sort' call
  // Inline function 'kotlin.apply' call
  var this_0 = new (SortBuilder())();
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp = serializerOrContextual(createKType(getKClass(CareLocation()), arrayOf([]), false));
  var tmp$ret$4 = isInterface(tmp, KSerializer()) ? tmp : THROW_CCE();
  var it = new (DataClassPathSelf())(tmp$ret$4);
  this_0.ascending_ijynum_k$(get_name(it));
  var tmp$ret$0 = this_0.build_1k0s4u_k$();
  SortOption_NameAscending_instance = new (SortOption())('NameAscending', 0, 'Name, ascending', tmp$ret$0);
  // Inline function 'com.lightningkite.services.database.sort' call
  // Inline function 'kotlin.apply' call
  var this_1 = new (SortBuilder())();
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_0 = serializerOrContextual(createKType(getKClass(CareLocation()), arrayOf([]), false));
  var tmp$ret$10 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
  var it_0 = new (DataClassPathSelf())(tmp$ret$10);
  this_1.descending_tl4o2_k$(get_name(it_0));
  var tmp$ret$6 = this_1.build_1k0s4u_k$();
  SortOption_NameDescending_instance = new (SortOption())('NameDescending', 1, 'Name, descending', tmp$ret$6);
  // Inline function 'com.lightningkite.services.database.sort' call
  // Inline function 'kotlin.apply' call
  var this_2 = new (SortBuilder())();
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_1 = serializerOrContextual(createKType(getKClass(CareLocation()), arrayOf([]), false));
  var tmp$ret$16 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
  var it_1 = new (DataClassPathSelf())(tmp$ret$16);
  this_2.ascending_ijynum_k$(get_providerName(it_1));
  this_2.ascending_ijynum_k$(get_name(it_1));
  var tmp$ret$12 = this_2.build_1k0s4u_k$();
  SortOption_Provider_instance = new (SortOption())('Provider', 2, 'Provider', tmp$ret$12);
  // Inline function 'com.lightningkite.services.database.sort' call
  // Inline function 'kotlin.apply' call
  var this_3 = new (SortBuilder())();
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_2 = serializerOrContextual(createKType(getKClass(CareLocation()), arrayOf([]), false));
  var tmp$ret$22 = isInterface(tmp_2, KSerializer()) ? tmp_2 : THROW_CCE();
  var it_2 = new (DataClassPathSelf())(tmp$ret$22);
  this_3.ascending_ijynum_k$(get_city(get_address(it_2)));
  this_3.ascending_ijynum_k$(get_name(it_2));
  var tmp$ret$18 = this_3.build_1k0s4u_k$();
  SortOption_City_instance = new (SortOption())('City', 3, 'City', tmp$ret$18);
  if (Companion_instance_2 === VOID) {
    Companion_instance;
    new (Companion())();
  }
}
var SortOption_NameAscending_instance;
var SortOption_NameDescending_instance;
var SortOption_Provider_instance;
var SortOption_City_instance;
function values() {
  static_init();
  return [SortOption_NameAscending_getInstance(), SortOption_NameDescending_getInstance(), SortOption_Provider_getInstance(), SortOption_City_getInstance()];
}
function get_entries() {
  static_init();
  if ($ENTRIES == null)
    $ENTRIES = enumEntries(values());
  return $ENTRIES;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance_2 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.$cachedSerializer$delegate_1 = lazy(tmp_0, LocationsListPage$SortOption$Companion$_anonymous__9ol70d);
      }
      serializer_9w0wvi_k$() {
        return _get_$cachedSerializer__te6jhj(this);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_9w0wvi_k$();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_2;
function Companion_getInstance_2() {
  static_init();
  return Companion_instance_2;
}
var $ENTRIES;
var SortOptionClass;
function SortOption() {
  if (SortOptionClass === VOID) {
    class $ extends Enum() {
      constructor(name, ordinal, displayName, sort) {
        super(name, ordinal);
        this.displayName_1 = displayName;
        this.sort_1 = sort;
      }
    }
    initMetadataForClass($, 'SortOption', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_2});
    SortOptionClass = $;
  }
  return SortOptionClass;
}
function LocationsListPage$_get_title_$lambda_oj9syz($this$remember) {
  return $this$remember.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_locationsPageTitle_w1kct0_k$();
}
function LocationsListPage$searchCondition$lambda$lambda(word) {
  return allTextFieldsContain(Companion_getInstance().serializer_9w0wvi_k$(), word);
}
function LocationsListPage$render$lambda($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_locationsPageTitle_w1kct0_k$();
}
function LocationsListPage$render$lambda$lambda(it) {
  return it.displayName_1;
}
function LocationsListPage$render$lambda$slambda(this$0, $this_exportButton) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    var tmp = Companion_instance_3;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_currentSessionNotNull();
    var tmp_0 = (yield* await_0(this_0, $completion)).api_1;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = this$0.searchCondition_1;
    var tmp$ret$1 = yield* await_0(this_1, $completion);
    var rows = yield* tmp.fetchAll_yitdfi_k$(tmp_0, tmp$ret$1, $completion);
    var csv = (new (CsvFormat())(new (StringDeferringConfig())(EmptySerializersModule(), VOID, ''))).encodeToString_k0apqx_k$(ListSerializer(Companion_instance_3.serializer_9w0wvi_k$()), rows);
    yield* download($this_exportButton.get_context_h02k06_k$(), 'locations.csv', toBlob(csv, 'text/csv'), VOID, $completion);
    return Unit_instance;
  }), 1);
}
function LocationsListPage$render$lambda_0(it) {
  return new (LocationDetailPage())(it._id_1);
}
function LocationsListPage$render$lambda_1($this$text) {
  return $this$text.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_locationNameLabel_iz62q3_k$();
}
function LocationsListPage$render$lambda_2($this$text, it) {
  return it.name_1;
}
function LocationsListPage$render$lambda_3($this$text) {
  return $this$text.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_locationProviderLabel_b4amqt_k$();
}
function LocationsListPage$render$lambda_4($this$text, it) {
  return it.providerName_1;
}
function LocationsListPage$render$lambda_5($this$text) {
  return $this$text.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_locationCityLabel_jq20et_k$();
}
function LocationsListPage$render$lambda_6($this$text, it) {
  return it.address_1.toCityState_srlsgl_k$();
}
function LocationsListPage$render$lambda_7($this$text) {
  return $this$text.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_locationContactColumnLabel_7u4hlo_k$();
}
function LocationsListPage$render$lambda_8($this$text, it) {
  return it.contact_1.name_1;
}
function LocationsListPage$render$lambda_9($this$text) {
  return $this$text.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_locationPhoneColumnLabel_xybcky_k$();
}
function LocationsListPage$render$lambda_10($this$text, it) {
  var tmp0_safe_receiver = it.contact_1.phone_1;
  var tmp;
  var tmp_0 = tmp0_safe_receiver;
  if ((tmp_0 == null ? null : new (PhoneNumber())(tmp_0)) == null) {
    tmp = null;
  } else {
    tmp = PhoneNumber__toString_impl_7i2x3q(tmp0_safe_receiver);
  }
  var tmp1_elvis_lhs = tmp;
  return tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
}
function LocationsListPage$render$lambda_11($this$shownWhen) {
  return get_current(Companion_instance_0).equals(Platform_Web_getInstance());
}
function SortOption_NameAscending_getInstance() {
  static_init();
  return SortOption_NameAscending_instance;
}
function SortOption_NameDescending_getInstance() {
  static_init();
  return SortOption_NameDescending_instance;
}
function SortOption_Provider_getInstance() {
  static_init();
  return SortOption_Provider_instance;
}
function SortOption_City_getInstance() {
  static_init();
  return SortOption_City_instance;
}
var LocationsListPageClass;
function LocationsListPage() {
  if (LocationsListPageClass === VOID) {
    class $ {
      constructor() {
        this.textSearch_1 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$('');
        var tmp = this;
        // Inline function 'kotlin.time.Companion.seconds' call
        Companion_getInstance_0();
        var tmp$ret$0 = toDuration(0.25, DurationUnit_SECONDS_getInstance());
        tmp.debouncedTextSearch_1 = debounce(this.textSearch_1, tmp$ret$0, get_AppScope());
        this.filter_1 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(new (LocationFilters())());
        var tmp_0 = this;
        tmp_0.searchCondition_1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.invoke_r7m7el_k$(this.debouncedTextSearch_1);
          return And().new_com_lightningkite_services_database_Condition_And_ln02sz_k$([textSearchCondition(tmp, LocationsListPage$searchCondition$lambda$lambda), $this$remember.invoke_r7m7el_k$(this.filter_1).toCondition_oj74tc_k$()]);
        });
        this.sort_1 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(first(get_entries()));
        var tmp_1 = this;
        tmp_1.data_1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_careLocations_f1rtw_k$();
          var tmp_0 = new (Query())($this$remember.invoke_r7m7el_k$(this.searchCondition_1), $this$remember.invoke_r7m7el_k$(this.sort_1).sort_1, VOID, 50);
          // Inline function 'kotlin.time.Companion.minutes' call
          Companion_getInstance_0();
          var tmp$ret$1 = toDuration_0(5, DurationUnit_MINUTES_getInstance());
          return tmp.list$default_sjz00l_k$(tmp_0, VOID, tmp$ret$1);
        });
      }
      get_title_iz32un_k$() {
        return remember(VOID, VOID, VOID, VOID, LocationsListPage$_get_title_$lambda_oj9syz);
      }
      render_w3x9d1_k$(_this__u8e3s4) {
        // Inline function 'org.thecommunitygroupinc.cares.views.components.page' call
        var this_0 = get_scrolling(_this__u8e3s4);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_1 = maxWidth(this_0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element = new (RowOrCol())(this_1.get_context_h02k06_k$());
        ensureOutermostElement(element);
        this_1.willAddChild_hz2iwc_k$(element);
        element.set_vertical_nuap32_k$(true);
        element.set_themeBase_daz04n_k$(Companion_getInstance_1().fromParentNonCascading_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        var this_2 = themed(element, CompactSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_0 = new (RowOrCol())(this_2.get_context_h02k06_k$());
        ensureOutermostElement(element_0);
        this_2.willAddChild_hz2iwc_k$(element_0);
        element_0.set_vertical_nuap32_k$(false);
        // Inline function 'com.lightningkite.kiteui.views.direct.h1' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        var this_3 = get_atBottomStart(element_0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_1 = new (TextView())(this_3.get_context_h02k06_k$());
        ensureOutermostElement(element_1);
        this_3.willAddChild_hz2iwc_k$(element_1);
        element_1.set_themeChoice_py59um_k$(element_1.get_themeChoice_22tyn3_k$().plus_duvq05_k$(HeaderSemantic_getInstance().plus_duvq05_k$(get_H1Semantic())));
        var tmp = KMutableProperty0();
        var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_1);
        var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_1));
        element_1.invoke_bnq13k_k$(tmp_1, LocationsListPage$render$lambda);
        element_1.onStartup_vrxh3i_k$();
        this_3.addChild_2qpft2_k$(element_1);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        var this_4 = weight(element_0, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_2 = new (Space())(this_4.get_context_h02k06_k$());
        ensureOutermostElement(element_2);
        this_4.willAddChild_hz2iwc_k$(element_2);
        element_2.onStartup_vrxh3i_k$();
        this_4.addChild_2qpft2_k$(element_2);
        searchField(element_0, this.textSearch_1);
        sortSelect(element_0, ($this$sortSelect) => {
          var tmp = _Constant___init__impl__v45mub(toList(get_entries()));
          $this$sortSelect.bind_64a41i_k$(this.sort_1, new (Constant())(tmp), LocationsListPage$render$lambda$lambda);
          return Unit_instance;
        });
        locationFilters(element_0, this.filter_1);
        exportButton(element_0, ($this$exportButton) => {
          $this$exportButton.set_action_2ds022_k$(Action('Export locations', VOID, VOID, VOID, VOID, VOID, LocationsListPage$render$lambda$slambda(this, $this$exportButton)));
          return Unit_instance;
        });
        element_0.onStartup_vrxh3i_k$();
        this_2.addChild_2qpft2_k$(element_0);
        locationFilterChips(element, this.filter_1);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        var tmp_2 = weight(element, 1.0);
        var tmp_3 = remember(VOID, VOID, VOID, VOID, ($this$remember) => $this$remember.invoke_r7m7el_k$(this.data_1));
        var tmp_4 = LocationsListPage$render$lambda_0;
        var tmp_5 = Companion_instance_1;
        var tmp_6 = LocationsListPage$render$lambda_1;
        var tmp_7 = tmp_5.text$default_gwb2zv_k$(tmp_6, VOID, LocationsListPage$render$lambda_2);
        var tmp_8 = Companion_instance_1;
        var tmp_9 = LocationsListPage$render$lambda_3;
        var tmp_10 = tmp_8.text$default_gwb2zv_k$(tmp_9, VOID, LocationsListPage$render$lambda_4);
        var tmp_11 = Companion_instance_1;
        var tmp_12 = LocationsListPage$render$lambda_5;
        var tmp_13 = tmp_11.text$default_gwb2zv_k$(tmp_12, VOID, LocationsListPage$render$lambda_6);
        var tmp_14 = Companion_instance_1;
        var tmp_15 = LocationsListPage$render$lambda_7;
        var tmp_16 = tmp_14.text$default_gwb2zv_k$(tmp_15, VOID, LocationsListPage$render$lambda_8);
        var tmp_17 = Companion_instance_1;
        var tmp_18 = LocationsListPage$render$lambda_9;
        tableRecycler(tmp_2, tmp_3, tmp_4, [tmp_7, tmp_10, tmp_13, tmp_16, tmp_17.text$default_gwb2zv_k$(tmp_18, VOID, LocationsListPage$render$lambda_10)]);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        var this_5 = shownWhen(element, VOID, VOID, LocationsListPage$render$lambda_11);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_3 = new (Space())(this_5.get_context_h02k06_k$(), 1.0);
        ensureOutermostElement(element_3);
        this_5.willAddChild_hz2iwc_k$(element_3);
        element_3.onStartup_vrxh3i_k$();
        this_5.addChild_2qpft2_k$(element_3);
        element.onStartup_vrxh3i_k$();
        this_1.addChild_2qpft2_k$(element);
        return Unit_instance;
      }
    }
    initMetadataForClass($, 'LocationsListPage', LocationsListPage, VOID, [Page()]);
    LocationsListPageClass = $;
  }
  return LocationsListPageClass;
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      *fetchAll_yitdfi_k$(api, condition, $completion) {
        // Inline function 'kotlin.collections.map' call
        var this_0 = yield* api.get_careLocation_drerzj_k$().query_o986pg_k$(new (Query())(condition, VOID, VOID, 2147483647), $completion);
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_0, 10));
        var _iterator__ex2g4s = this_0.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var item = _iterator__ex2g4s.next_20eer_k$();
          var tmp0_safe_receiver = item.contact_1.email_1;
          var tmp;
          var tmp_0 = tmp0_safe_receiver;
          if ((tmp_0 == null ? null : new (EmailAddress())(tmp_0)) == null) {
            tmp = null;
          } else {
            tmp = EmailAddress__toString_impl_artjh3(tmp0_safe_receiver);
          }
          var tmp_1 = tmp;
          var tmp1_safe_receiver = item.contact_1.phone_1;
          var tmp_2;
          var tmp_3 = tmp1_safe_receiver;
          if ((tmp_3 == null ? null : new (PhoneNumber())(tmp_3)) == null) {
            tmp_2 = null;
          } else {
            tmp_2 = PhoneNumber__toString_impl_7i2x3q(tmp1_safe_receiver);
          }
          var tmp$ret$2 = new (LocationCsvRow())(item.name_1, item.providerName_1, item.address_1.line1__1, item.address_1.line2__1, item.address_1.city_1, item.address_1.state_1, item.address_1.postalCode_1, item.contact_1.name_1, tmp_1, tmp_2, item.active_1);
          destination.add_utx5q5_k$(tmp$ret$2);
        }
        return destination;
      }
      serializer_9w0wvi_k$() {
        return $serializer_getInstance();
      }
    }
    initMetadataForCompanion($, VOID, VOID, [2]);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_3;
function Companion_getInstance_3() {
  return Companion_instance_3;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        $serializer_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.views.locations.LocationCsvRow', this, 11);
        tmp0_serialDesc.addElement_5pzumi_k$('name', false);
        tmp0_serialDesc.addElement_5pzumi_k$('provider', false);
        tmp0_serialDesc.addElement_5pzumi_k$('addressLine1', false);
        tmp0_serialDesc.addElement_5pzumi_k$('addressLine2', false);
        tmp0_serialDesc.addElement_5pzumi_k$('city', false);
        tmp0_serialDesc.addElement_5pzumi_k$('state', false);
        tmp0_serialDesc.addElement_5pzumi_k$('postalCode', false);
        tmp0_serialDesc.addElement_5pzumi_k$('contactName', false);
        tmp0_serialDesc.addElement_5pzumi_k$('contactEmail', false);
        tmp0_serialDesc.addElement_5pzumi_k$('contactPhone', false);
        tmp0_serialDesc.addElement_5pzumi_k$('active', false);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_17344w_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 0, value.name_1);
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 1, value.provider_1);
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 2, value.addressLine1__1);
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 3, value.addressLine2__1);
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 4, value.city_1);
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 5, value.state_1);
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 6, value.postalCode_1);
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 7, value.contactName_1);
        tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 8, StringSerializer_getInstance(), value.contactEmail_1);
        tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 9, StringSerializer_getInstance(), value.contactPhone_1);
        tmp1_output.encodeBooleanElement_ydht7q_k$(tmp0_desc, 10, value.active_1);
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_17344w_k$(encoder, value instanceof LocationCsvRow() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_local7 = null;
        var tmp12_local8 = null;
        var tmp13_local9 = null;
        var tmp14_local10 = false;
        var tmp15_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp15_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp15_input.decodeStringElement_3oenpg_k$(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp15_input.decodeStringElement_3oenpg_k$(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp15_input.decodeStringElement_3oenpg_k$(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp15_input.decodeStringElement_3oenpg_k$(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp15_input.decodeStringElement_3oenpg_k$(tmp0_desc, 4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp15_input.decodeStringElement_3oenpg_k$(tmp0_desc, 5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp15_input.decodeStringElement_3oenpg_k$(tmp0_desc, 6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp15_input.decodeStringElement_3oenpg_k$(tmp0_desc, 7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          tmp12_local8 = tmp15_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 8, StringSerializer_getInstance(), tmp12_local8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          tmp13_local9 = tmp15_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 9, StringSerializer_getInstance(), tmp13_local9);
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
          tmp14_local10 = tmp15_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 10);
          tmp3_bitMask0 = tmp3_bitMask0 | 1024;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp15_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp15_input.decodeStringElement_3oenpg_k$(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp15_input.decodeStringElement_3oenpg_k$(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp15_input.decodeStringElement_3oenpg_k$(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp15_input.decodeStringElement_3oenpg_k$(tmp0_desc, 3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp15_input.decodeStringElement_3oenpg_k$(tmp0_desc, 4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp15_input.decodeStringElement_3oenpg_k$(tmp0_desc, 5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp15_input.decodeStringElement_3oenpg_k$(tmp0_desc, 6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp15_input.decodeStringElement_3oenpg_k$(tmp0_desc, 7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                tmp12_local8 = tmp15_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 8, StringSerializer_getInstance(), tmp12_local8);
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              case 9:
                tmp13_local9 = tmp15_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 9, StringSerializer_getInstance(), tmp13_local9);
                tmp3_bitMask0 = tmp3_bitMask0 | 512;
                break;
              case 10:
                tmp14_local10 = tmp15_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 10);
                tmp3_bitMask0 = tmp3_bitMask0 | 1024;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp15_input.endStructure_1xqz0n_k$(tmp0_desc);
        return LocationCsvRow().new_org_thecommunitygroupinc_cares_views_locations_LocationCsvRow_vckl9f_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), BooleanSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var $serializer_instance;
function $serializer_getInstance() {
  if ($serializer_instance === VOID)
    new ($serializer())();
  return $serializer_instance;
}
var LocationCsvRowClass;
function LocationCsvRow() {
  if (LocationCsvRowClass === VOID) {
    class $ {
      constructor(name, provider, addressLine1, addressLine2, city, state, postalCode, contactName, contactEmail, contactPhone, active) {
        this.name_1 = name;
        this.provider_1 = provider;
        this.addressLine1__1 = addressLine1;
        this.addressLine2__1 = addressLine2;
        this.city_1 = city;
        this.state_1 = state;
        this.postalCode_1 = postalCode;
        this.contactName_1 = contactName;
        this.contactEmail_1 = contactEmail;
        this.contactPhone_1 = contactPhone;
        this.active_1 = active;
      }
      toString() {
        return 'LocationCsvRow(name=' + this.name_1 + ', provider=' + this.provider_1 + ', addressLine1=' + this.addressLine1__1 + ', addressLine2=' + this.addressLine2__1 + ', city=' + this.city_1 + ', state=' + this.state_1 + ', postalCode=' + this.postalCode_1 + ', contactName=' + this.contactName_1 + ', contactEmail=' + this.contactEmail_1 + ', contactPhone=' + this.contactPhone_1 + ', active=' + this.active_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.name_1);
        result = imul(result, 31) + getStringHashCode(this.provider_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.addressLine1__1) | 0;
        result = imul(result, 31) + getStringHashCode(this.addressLine2__1) | 0;
        result = imul(result, 31) + getStringHashCode(this.city_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.state_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.postalCode_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.contactName_1) | 0;
        result = imul(result, 31) + (this.contactEmail_1 == null ? 0 : getStringHashCode(this.contactEmail_1)) | 0;
        result = imul(result, 31) + (this.contactPhone_1 == null ? 0 : getStringHashCode(this.contactPhone_1)) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.active_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof LocationCsvRow()))
          return false;
        if (!(this.name_1 === other.name_1))
          return false;
        if (!(this.provider_1 === other.provider_1))
          return false;
        if (!(this.addressLine1__1 === other.addressLine1__1))
          return false;
        if (!(this.addressLine2__1 === other.addressLine2__1))
          return false;
        if (!(this.city_1 === other.city_1))
          return false;
        if (!(this.state_1 === other.state_1))
          return false;
        if (!(this.postalCode_1 === other.postalCode_1))
          return false;
        if (!(this.contactName_1 === other.contactName_1))
          return false;
        if (!(this.contactEmail_1 == other.contactEmail_1))
          return false;
        if (!(this.contactPhone_1 == other.contactPhone_1))
          return false;
        if (!(this.active_1 === other.active_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_views_locations_LocationCsvRow_vckl9f_k$(seen0, name, provider, addressLine1, addressLine2, city, state, postalCode, contactName, contactEmail, contactPhone, active, serializationConstructorMarker) {
        if (!(2047 === (2047 & seen0))) {
          throwMissingFieldException(seen0, 2047, $serializer_getInstance().descriptor_1);
        }
        var $this = createThis(this);
        $this.name_1 = name;
        $this.provider_1 = provider;
        $this.addressLine1__1 = addressLine1;
        $this.addressLine2__1 = addressLine2;
        $this.city_1 = city;
        $this.state_1 = state;
        $this.postalCode_1 = postalCode;
        $this.contactName_1 = contactName;
        $this.contactEmail_1 = contactEmail;
        $this.contactPhone_1 = contactPhone;
        $this.active_1 = active;
        return $this;
      }
    }
    initMetadataForClass($, 'LocationCsvRow', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance});
    LocationCsvRowClass = $;
  }
  return LocationCsvRowClass;
}
//region block: init
Companion_instance_3 = new (Companion_0())();
//endregion
//region block: exports
export {
  SortOption as SortOption28u5d223wqzoa,
  LocationsListPage as LocationsListPage204x74tlyxper,
};
//endregion

//# sourceMappingURL=LocationsListPage.mjs.map
